// Import style lib
import styled from 'styled-components';

// Import colors
import colors from '../../utils/styles/colors';

// Styled Search Input
export const SearchInput = styled.input.withConfig({
    shouldForwardProp: (prop) => !['error'].includes(prop),
})`
    /* Appearance */
    border: 1px solid #ccc;
    border-radius: 15px;

    border-color: ${(props) => (props.error ? 'red' : '#ccc')};
    box-shadow: ${(props) => (props.error ? '0 0 5px red' : 'none')};

    /* Size */
    height: 32px;
    width: ${(props) => props.width}px;

    /* Spacing */
    padding: 0px 10px;

    /* Event */
    &:focus {
        border-color: steelblue;
        box-shadow: 0 0 5px steelblue;
    }
`;

// Styled Search Button
export const SearchButton = styled.button`
    /* Events */
    cursor: pointer;
    &:hover {
        filter: brightness(1.2);
    }
`;

// Styled Search icon
export const SearchIcon = styled.svg`
    /* Appearance */
    fill: ${colors.primaryBeige};

    /* Size */
    width: ${(props) => props.width}px;
    height: ${(props) => props.width}px;
`;
